<template>
  <div>
    <v-expansion-panels       
      v-if="!showPdf"
      v-model="tabSections">
      <v-expansion-panel
        v-for="section in sections"
        :key="section"
      >
        <v-expansion-panel-header>
          {{ section }}
          <template v-slot:actions>
            <v-icon color="primary">$expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table class="table" fixed-header height="100%"  v-if="!showPdf">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="table-header">Item</th>
                  <th class="table-header">Description</th>
                  <th class="table-header">Last Updated</th>
                  <th class="table-header">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="doc in tabDocuments" :key="doc.title" @click="getPdf(doc.id,doc.permission,doc.title)">
                  <td class="table-row">{{doc.title}}</td>
                  <td class="table-row">{{doc.subtitle}}</td>
                  <td class="table-row">{{doc.publish_date}}</td>
                  <td class="table-row">{{doc.permission=='D'?'enable':doc.permission=='R'?'enable':'disable'}}</td>
                </tr>
              </tbody>       
            </template>
            <div v-if="empty">No Slides Available</div>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <PdfViewer 
      v-if="showPdf" 
      v-bind:documentId="document_id"
      v-bind:documentName="document_title"
      v-bind:documentPermission="document_permission"
      @close-pdfviewer="onPdfViewerClose"
      />
  </div>
</template>
<script>
  
  import PdfViewer from '@/components/PdfViewer.vue'
  import Documents from '@/api/documents'
  import Vue from 'vue'

  export default {
    components:{
      PdfViewer
    },
    data: () => ({
      empty:false,
      tabSections:[],
      sections:[],
      document_id: 0,
      document_title: '',
      document_permission: '',
      showPdf: false,
      documents: [],
      tabDocuments: [],
    }),
    created(){
      this.getSlides()
    },
    computed:{
      userId () {
                return this.$store.getters.getUser.id
            },
    },
    methods:{
      getPdf(id,permission,title){
        if(permission=="R"|| permission=="D"){
          this.document_id = id;
          this.document_permission = permission;
          this.document_title = title;
          this.showPdf=true;
        }else{
          Vue.notify({
            group: 'general',
            type: 'error',
            text: 'You do not have permission to view this document.'
          })
        }

      },
      getSlides () {
        const vm = this 
        return new Promise((resolve, reject) => {
          Documents.getDocuments('slides',this.userId).then(
            data => {
              vm.documents = _.orderBy(data, ['publish_date'], ['desc']);
              vm.tabDocuments = _.cloneDeep(vm.documents)
              _.forEach(_.uniqBy(data, 'section'), function(input) {
                vm.sections.push(input.section)
              })
              if(_.size(vm.documents)==0){
                vm.empty=true
              }
              else{
                vm.empty=false
              }
            }
          )
        })
      },
      onPdfViewerClose(){ 
        this.showPdf=false;
      }
    },
    watch:{
      tabSections:function(val){
        this.tabDocuments = _.filter(this.documents, ['section', this.sections[val]]);
      }
    }
  }
</script>
<style>
.loading{
  margin-top: 200px;
}
.table {
  margin-top: 10px;
  margin-left: 30px;
}
.table-header{
  font-size: small !important;
  align-content: center;
  background-color: #d4d6e2 !important;
  font-weight: 600!important;
}
.table-row{
  font-size: small !important;
  align-content: center;
  background-color: transparent !important;
  font-weight: 400!important;
}
</style>